export const FIXED_TABLE_COLUMNS = {
  CHECKBOX: 'checkbox',
  NAME: 'name',
  EMAIL: 'email',
};

export const DYNAMIC_TABLE_COLUMNS = { NDA: 'nda' };

export const FIXED_COLUMN_TRANSLATIONS = {
  [FIXED_TABLE_COLUMNS.NAME]: 'name',
  [FIXED_TABLE_COLUMNS.EMAIL]: 'email',
};

export const SORT_VALUES = {
  NAME: FIXED_TABLE_COLUMNS.NAME,
  EMAIL: FIXED_TABLE_COLUMNS.EMAIL,
  STATUS: 'sortStatus',
};

export const FIXED_COLUMN_SORTING_VALUES = {
  [FIXED_TABLE_COLUMNS.NAME]: SORT_VALUES.NAME,
  [FIXED_TABLE_COLUMNS.EMAIL]: SORT_VALUES.EMAIL,
};

export const FIXED_COLUMN_SIZE = {
  [FIXED_TABLE_COLUMNS.CHECKBOX]: 50,
  [FIXED_TABLE_COLUMNS.NAME]: 200,
  [FIXED_TABLE_COLUMNS.EMAIL]: 200,
};

export const DYNAMIC_COLUMN_SIZE = 200;

export const NDA_SORT_CLEAR_FIELDS = ['dataRoomNdaId'];
